module.exports = __webpack_public_path__ + "img/SKMJ_speed.2321836c.jpg";